import { useContext, useEffect, useState } from 'react';
import UserContext from '../store/User/UserContext';
import { useHEMTLocations } from './api/useHEMTLocations';
import { getCookie } from '../utils';
import { Location } from '../types/Location.interface';
import { isUserHasLocation } from '../utils/authUtils';

export const usePreferredUserLocation = (
    selectedLocation: string | number
): [Location | null, React.Dispatch<React.SetStateAction<Location | null>>] => {
    const loggedInUser = useContext(UserContext);
    const [location, setLocation] = useState<Location | null>(null);
    const locations: Location[] = useHEMTLocations();
    const cookieLocation = getCookie('location');
    const preferredLocationId = Number(selectedLocation || cookieLocation);

    useEffect(() => {
        if (!loggedInUser || !preferredLocationId) {
            return;
        }
        const preferredLocation = isUserHasLocation(loggedInUser, preferredLocationId)
            ? locations.find((location) => location.id === preferredLocationId)
            : locations.find((location) => location.id === loggedInUser.primaryLocationId) ||
              loggedInUser.primaryLocation;

        setLocation(preferredLocation || null);
    }, [locations, loggedInUser, preferredLocationId]);

    return [location, setLocation];
};
